import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=2307ec54"
import script from "./Order.ts?vue&type=script&lang=ts&external"
export * from "./Order.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports